import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ngo-and-government',
  templateUrl: './ngo-and-government.component.html',
  styleUrls: ['./ngo-and-government.component.css']
})
export class NgoAndGovernment implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}